import Router from "./router";
export default Router;

import Edit from "./edit";
export { Edit };
import Employees from "./employees";
export { Employees };
